import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { DamageCodeSearchTextForm } from '../../../form-model/damage-code-search-text.form.model';

@Component({
  selector: 'app-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './damage-code-search.component.html',
  styleUrl: './damage-code-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DamageCodeSearchComponent implements OnInit {
  @Input({ required: true }) damageCodeSearchTextForm!: FormGroup<DamageCodeSearchTextForm>;

  applySearchTextFilters() {
    this.damageCodeSearchTextForm.controls.appliedDCSearchTextFilter.setValue(true);
  }
  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit() {
    this.addControlsToTheFormGroup();
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  private addControlsToTheFormGroup() {
    const validTextSearchPattern = /^[A-Za-z]{2}$/;
    this.damageCodeSearchTextForm.addControl(
      'searchText',
      this.formBuilder.control<string | null>(null, {
        validators: [Validators.pattern(validTextSearchPattern)],
      }),
    );
    this.damageCodeSearchTextForm.addControl('appliedDCSearchTextFilter', this.formBuilder.control<boolean | null>(null));
  }
}
